import script from "./FinancialYear.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancialYear.vue?vue&type=script&setup=true&lang=js"

import "./FinancialYear.vue?vue&type=style&index=0&id=5fc5478a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc5478a"]])

export default __exports__